import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

declare let window: any;

@Injectable()
export class WindowNavigationService {
  constructor(private location: Location, private router: Router) {}

  back() {
    return 1 === window.history.length
      ? this.router.navigate(['/'])
      : this.location.back();
  }
}
